"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _rcTooltip = _interopRequireDefault(require("rc-tooltip"));
var _lodash = _interopRequireDefault(require("lodash"));
var _moment = _interopRequireDefault(require("moment"));
var _dateFns = require("date-fns");
var _SpeedControl = _interopRequireDefault(require("./scrubber/SpeedControl"));
var _OptionsBar = _interopRequireDefault(require("../components/OptionsBar"));
var _reactBootstrap = require("react-bootstrap");
var _utilities = require("../../../utilities");
var _helpers = require("../../lib/helpers");
var _mapState = require("../../../../dist/desktop/hooks/mapState");
var _trains = require("../geo-map/openlayers/trains");
var _playback = require("../../hooks/queries/playback");
var _constants = require("../../lib/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; } // import TimestampBar from "./scrubber/TimestampBar";
var Scrubber = function Scrubber(props) {
  var _mapState$auth, _mapState$auth2, _formatPlaybackFilena4, _formatPlaybackFilena5;
  var selected = props.selected,
    selectedText = props.selectedText,
    isMobile = props.isMobile;
  var _useMapState = (0, _mapState.useMapState)(),
    mapState = _useMapState.mapState,
    setTrains = _useMapState.setTrains,
    startPlayback = _useMapState.startPlayback,
    stopPlayback = _useMapState.stopPlayback,
    setTimestamp = _useMapState.setTimestamp,
    resetPlayback = _useMapState.resetPlayback,
    unselect = _useMapState.unselect;
  var playback = mapState.playback;
  var isPlaying = playback.isPlaying;
  // console.log(playback)

  var timelineRef = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    timestampPreview = _useState2[0],
    setTimestampPreview = _useState2[1];
  var _useState3 = (0, _react.useState)(0),
    _useState4 = _slicedToArray(_useState3, 2),
    timestampSelector = _useState4[0],
    setTimestampSelector = _useState4[1];
  var _useState5 = (0, _react.useState)([]),
    _useState6 = _slicedToArray(_useState5, 2),
    playbackTimeouts = _useState6[0],
    setPlaybackTimeouts = _useState6[1];
  var _useState7 = (0, _react.useState)(null),
    _useState8 = _slicedToArray(_useState7, 2),
    loadingProgress = _useState8[0],
    setLoadingProgress = _useState8[1];
  var showPlaybackFetchProgress = function showPlaybackFetchProgress(fileLength, step) {
    var percent = step / fileLength * 100;
    setLoadingProgress(Math.round(percent));
  };
  var _useTrainPlayback = (0, _playback.useTrainPlayback)(mapState.playback.from, mapState.playback.to, mapState === null || mapState === void 0 ? void 0 : (_mapState$auth = mapState.auth) === null || _mapState$auth === void 0 ? void 0 : _mapState$auth.token, (_mapState$auth2 = mapState.auth) === null || _mapState$auth2 === void 0 ? void 0 : _mapState$auth2.mapLayerToken, showPlaybackFetchProgress),
    isFetchingFilenames = _useTrainPlayback.isFetchingFilenames,
    isFetchingAllTrains = _useTrainPlayback.isFetchingAllTrains,
    filenames = _useTrainPlayback.filenames,
    allTrains = _useTrainPlayback.allTrains;
  var endPlayback = function endPlayback() {
    //wipe out timeouts
    //null timestamp
    setTimestampPreview(null);
    stopPlayingTrains();
    resetPlayback();
  };
  var playTrains = function playTrains(start) {
    var i = start;
    var nextTimeout = setTimeout(function () {
      handlePlaybackTick(i);
      i++;
      if (i < filenames.length && isPlaying) {
        playTrains(i);
      }
    }, 200);
    setPlaybackTimeouts(function (old) {
      return [].concat(_toConsumableArray(old), [nextTimeout]);
    });
  };
  var stopPlayingTrains = function stopPlayingTrains() {
    // gets every existing timeout and clears them, resets timeouts
    var timeoutsToClear = _toConsumableArray(playbackTimeouts);
    timeoutsToClear.forEach(function (timeout) {
      clearTimeout(timeout);
    });
    setPlaybackTimeouts([]);
  };
  var handlePlaybackTick = function handlePlaybackTick(value) {
    // responsible for managing the individual ticks of playback
    // separate from the click handler to allow users to skip around in the playback
    handleTimelineChange(value);
    var _formatPlaybackFilena = (0, _helpers.formatPlaybackFilename)(filenames[value]),
      zonedDate = _formatPlaybackFilena.zonedDate;
    setTimestamp(zonedDate);
    setTrains(allTrains[filenames[value]]);
  };
  var handleTimelineChange = function handleTimelineChange(value) {
    // responsible exclusively for setting the component-level timestamp value to be rendered in the 
    // green box above the scrubber
    if (timestampSelector === value || !value) {
      return false;
    }
    setTimestampSelector(value);
    var _formatPlaybackFilena2 = (0, _helpers.formatPlaybackFilename)(filenames[value]),
      formattedDate = _formatPlaybackFilena2.formattedDate;
    setTimestampPreview(formattedDate);
  };
  var handleTimelineClick = function handleTimelineClick(value) {
    // responsible exclusively for passing the final-dragged or clicked value into the change func,
    // getting the desired slice of trains, and setting those into reducer state along with the timestamp
    if (!value) {
      return false;
    }
    if (playback.isPlaying) {
      console.log('skipping around... ');
      stopPlayingTrains();
      playTrains(value);
    }
    handleTimelineChange(value);
    var _formatPlaybackFilena3 = (0, _helpers.formatPlaybackFilename)(filenames[value]),
      zonedDate = _formatPlaybackFilena3.zonedDate;
    setTimestamp(zonedDate);
    setTrains(allTrains[filenames[value]]);
  };
  (0, _react.useEffect)(function () {
    if (isPlaying) {
      playTrains(timestampSelector);
    } else {
      stopPlayingTrains();
    }
  }, [isPlaying]);
  return /*#__PURE__*/_react["default"].createElement("section", {
    id: "scrubber-region",
    ref: timelineRef
  }, timestampPreview && /*#__PURE__*/_react["default"].createElement("div", {
    id: "timestamp"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "timestamp-bar"
  }, timestampPreview)), (isFetchingAllTrains || isFetchingFilenames) && /*#__PURE__*/_react["default"].createElement("div", {
    id: "timestamp"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "timestamp-bar"
  }, "Loading train playback data...", loadingProgress && " ".concat(loadingProgress, "%"))), mapState.playback.showScrubber && /*#__PURE__*/_react["default"].createElement("div", {
    id: "map-scrubber"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "playback-control"
  }, isPlaying ? /*#__PURE__*/_react["default"].createElement("i", {
    className: "fa fa-pause",
    "aria-hidden": "true",
    onClick: function onClick() {
      return stopPlayback();
    }
  }) : /*#__PURE__*/_react["default"].createElement("i", {
    className: "fa fa-play",
    "aria-hidden": "true",
    onClick: function onClick() {
      if (!isFetchingAllTrains || !isFetchingFilenames) {
        unselect();
        startPlayback();
      }
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "playback-timeline-wrapper"
  }, /*#__PURE__*/_react["default"].createElement(_reactBootstrap.Form.Range, {
    id: "time-selection",
    className: "playback-timeline",
    min: "0",
    disabled: isFetchingAllTrains || isFetchingFilenames,
    max: filenames ? filenames.length - 1 : '0',
    value: timestampSelector,
    onChange: function onChange(event) {
      return handleTimelineChange(event.target.value);
    },
    onClick: function onClick(event) {
      return handleTimelineClick(event.target.value);
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "timeline-labels"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "start"
  }, (filenames === null || filenames === void 0 ? void 0 : filenames.length) && ((_formatPlaybackFilena4 = (0, _helpers.formatPlaybackFilename)(filenames[0])) === null || _formatPlaybackFilena4 === void 0 ? void 0 : _formatPlaybackFilena4.formattedDate)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "now"
  }, (filenames === null || filenames === void 0 ? void 0 : filenames.length) && ((_formatPlaybackFilena5 = (0, _helpers.formatPlaybackFilename)(filenames[filenames.length - 1])) === null || _formatPlaybackFilena5 === void 0 ? void 0 : _formatPlaybackFilena5.formattedDate))))), /*#__PURE__*/_react["default"].createElement(_OptionsBar["default"], {
    selected: selected,
    selectedText: selectedText,
    unselect: unselect,
    endPlayback: endPlayback
  }));
};
var _default = Scrubber;
exports["default"] = _default;